<script setup>
import PlatformIcon from '@shared-components/ui/PlatformIcon.vue'
import {defineProps} from 'vue'

defineProps({
  platform: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <td>
    <div class="d-flex align-items-center custom gap-3">
      <platform-icon v-if="platform" :platform="platform" class="max-w-20" />
      <slot />
    </div>
  </td>
</template>
